'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidTrain = function IoAndroidTrain(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm6 27.1v-16.7c0-5.9 6.4-6.6 13.8-6.6s13.7 0.7 13.7 6.6v16.7c0 3.3-2.6 5.8-5.9 5.8l2.2 2.1v1.3h-20v-1.3l2.1-2.1c-3.3 0-5.9-2.5-5.9-5.8z m13.8 2.3c1.7 0 3.1-1.4 3.1-3.1s-1.4-3.2-3.1-3.2-3.2 1.4-3.2 3.2 1.4 3.1 3.2 3.1z m10-11.9v-7.5h-20v7.5h20z' })
        )
    );
};

exports.default = IoAndroidTrain;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-train.js
// module id = 2153
// module chunks = 0